<template>
  <div class="row restricted-tab edit-remote-readiness">
    <!-- <div class="col-12 mb-3">
      <h2>Remote work readiness</h2>
      <label class="description">
        Trust is the basic element to make this work, then comes communication and
        process.
        Let's see how ready your team is to work from home.
      </label>
    </div>-->

    <div class="col-12">
      <div class="form-group">
        <label>
          Do you use video conference tools like Zoom, Hangouts,
          Slack, etc.?
        </label>
        <br />
        <div class="btn-group btn-group-toggle row">
          <div class="col-md-4 col-6">
            <label
              class="btn radio-btn"
              v-bind:class="{
                                active:
                                    true === remote_measures.video_conference
                            }"
            >
              <img
                v-if="remote_measures.video_conference"
                v-bind:src="'/images/icon-checked-white.svg'"
                alt
                class="mr-2"
              />
              <input
                type="radio"
                name="videoConferenceOptions"
                id="videoConferenceOptionsTrue"
                :value="true"
                autocomplete="off"
                v-model="remote_measures.video_conference"
              />Yes
            </label>
          </div>
          <div class="col-md-4 col-6">
            <label
              class="btn radio-btn"
              v-bind:class="{
                                active:
                                    false === remote_measures.video_conference
                            }"
            >
              <img
                v-if="!remote_measures.video_conference"
                v-bind:src="'/images/icon-checked-white.svg'"
                alt
                class="mr-2"
              />
              <input
                type="radio"
                name="videoConferenceOptions"
                id="videoConferenceOptionsFalse"
                :value="false"
                autocomplete="off"
                v-model="remote_measures.video_conference"
              />No
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="form-group">
        <label>Do you use a project management tool like Trello?</label>
        <br />
        <div class="btn-group btn-group-toggle row">
          <div class="col-md-4 col-6">
            <label
              class="btn radio-btn"
              v-bind:class="{
                                active:
                                    true === remote_measures.project_management
                            }"
            >
              <img
                v-if="remote_measures.project_management"
                v-bind:src="'/images/icon-checked-white.svg'"
                alt
                class="mr-2"
              />
              <input
                type="radio"
                name="projectManagementOptions"
                id="projectManagementOptionsTrue"
                :value="true"
                autocomplete="off"
                v-model="remote_measures.project_management"
              />Yes
            </label>
          </div>
          <div class="col-md-4 col-6">
            <label
              class="btn radio-btn"
              v-bind:class="{
                                active:
                                    false === remote_measures.project_management
                            }"
            >
              <img
                v-if="!remote_measures.project_management"
                v-bind:src="'/images/icon-checked-white.svg'"
                alt
                class="mr-2"
              />
              <input
                type="radio"
                name="projectManagementOptions"
                id="projectManagementOptionsFalse"
                :value="false"
                autocomplete="off"
                v-model="remote_measures.project_management"
              />No
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="form-group">
        <label>Do you have clear SOPs?</label>
        <br />
        <div class="btn-group btn-group-toggle row">
          <div class="col-md-4 col-6">
            <label
              class="btn radio-btn"
              v-bind:class="{
                                active: true === remote_measures.clear_sop
                            }"
            >
              <img
                v-if="remote_measures.clear_sop"
                v-bind:src="'/images/icon-checked-white.svg'"
                alt
                class="mr-2"
              />
              <input
                type="radio"
                name="clearSOPOptions"
                id="clearSOPOptionsTrue"
                :value="true"
                autocomplete="off"
                v-model="remote_measures.clear_sop"
              />Yes
            </label>
          </div>
          <div class="col-md-4 col-6">
            <label
              class="btn radio-btn"
              v-bind:class="{
                                active: false === remote_measures.clear_sop
                            }"
            >
              <img
                v-if="!remote_measures.clear_sop"
                v-bind:src="'/images/icon-checked-white.svg'"
                alt
                class="mr-2"
              />
              <input
                type="radio"
                name="clearSOPOptions"
                id="clearSOPOptionsFalse"
                :value="false"
                autocomplete="off"
                v-model="remote_measures.clear_sop"
              />No
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="form-group">
        <label>
          Do you use a shared Cloud storage/collaboration tool like
          Google Drive, Dropbox, etc.?
        </label>
        <br />
        <div class="btn-group btn-group-toggle row">
          <div class="col-md-4 col-6">
            <label
              class="btn radio-btn"
              v-bind:class="{
                                active:
                                    true ===
                                    remote_measures.set_communications_protocol
                            }"
            >
              <img
                v-if="
                                    remote_measures.set_communications_protocol
                                "
                v-bind:src="'/images/icon-checked-white.svg'"
                alt
                class="mr-2"
              />
              <input
                type="radio"
                name="setCommunicationsProtocolOptions"
                id="setCommunicationsProtocolOptionsTrue"
                :value="true"
                autocomplete="off"
                v-model="
                                    remote_measures.set_communications_protocol
                                "
              />Yes
            </label>
          </div>
          <div class="col-md-4 col-6">
            <label
              class="btn radio-btn"
              v-bind:class="{
                                active:
                                    false ===
                                    remote_measures.set_communications_protocol
                            }"
            >
              <img
                v-if="
                                    !remote_measures.set_communications_protocol
                                "
                v-bind:src="'/images/icon-checked-white.svg'"
                alt
                class="mr-2"
              />
              <input
                type="radio"
                name="setCommunicationsProtocolOptions"
                id="setCommunicationsProtocolOptionsFalse"
                :value="false"
                autocomplete="off"
                v-model="
                                    remote_measures.set_communications_protocol
                                "
              />No
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="form-group">
        <label>Do you have a tech team in your company?</label>
        <br />
        <div class="btn-group btn-group-toggle row">
          <div class="col-md-4 col-6">
            <label
              class="btn radio-btn"
              v-bind:class="{
                                active: true === remote_measures.has_tech_team
                            }"
            >
              <img
                v-if="remote_measures.has_tech_team"
                v-bind:src="'/images/icon-checked-white.svg'"
                alt
                class="mr-2"
              />
              <input
                type="radio"
                name="haveTechTeamOptions"
                id="haveTechTeamOptionsTrue"
                :value="true"
                autocomplete="off"
                v-model="remote_measures.has_tech_team"
              />Yes
            </label>
          </div>
          <div class="col-md-4 col-6">
            <label
              class="btn radio-btn"
              v-bind:class="{
                                active: false === remote_measures.has_tech_team
                            }"
            >
              <img
                v-if="!remote_measures.has_tech_team"
                v-bind:src="'/images/icon-checked-white.svg'"
                alt
                class="mr-2"
              />
              <input
                type="radio"
                name="haveTechTeamOptions"
                id="haveTechTeamOptionsFalse"
                :value="false"
                autocomplete="off"
                v-model="remote_measures.has_tech_team"
              />No
            </label>
          </div>
        </div>
      </div>
    </div>

    <div v-if="remote_measures.has_tech_team">
      <div class="col-12">
        <h3 class="tech-team">Tech Team</h3>
        <label class="tech-team__description">
          Getting your tech team to work remotely is simple yet
          tricky. Start with the 2 important questions below.
        </label>
      </div>

      <div class="col-12">
        <div class="form-group">
          <label>
            Do your tech team schedule regular virtual
            meetings?
          </label>
          <br />
          <div class="btn-group btn-group-toggle row">
            <div class="col-md-4 col-6">
              <label
                class="btn radio-btn"
                v-bind:class="{
                                    active:
                                        true ===
                                        remote_measures.schedule_regular_scrums
                                }"
              >
                <img
                  v-if="
                                        remote_measures.schedule_regular_scrums
                                    "
                  v-bind:src="
                                        '/images/icon-checked-white.svg'
                                    "
                  alt
                  class="mr-2"
                />
                <input
                  type="radio"
                  name="regularScrumsOptions"
                  id="regularScrumsOptionsTrue"
                  :value="true"
                  autocomplete="off"
                  v-model="
                                        remote_measures.schedule_regular_scrums
                                    "
                />Yes
              </label>
            </div>
            <div class="col-md-4 col-6">
              <label
                class="btn radio-btn"
                v-bind:class="{
                                    active:
                                        false ===
                                        remote_measures.schedule_regular_scrums
                                }"
              >
                <img
                  v-if="
                                        !remote_measures.schedule_regular_scrums
                                    "
                  v-bind:src="
                                        '/images/icon-checked-white.svg'
                                    "
                  alt
                  class="mr-2"
                />
                <input
                  type="radio"
                  name="regularScrumsOptions"
                  id="regularScrumsOptionsFalse"
                  :value="false"
                  autocomplete="off"
                  v-model="
                                        remote_measures.schedule_regular_scrums
                                    "
                />No
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form-group">
          <label>Does your tech team use Git?</label>
          <br />
          <div class="btn-group btn-group-toggle row">
            <div class="col-md-4 col-6">
              <label
                class="btn radio-btn"
                v-bind:class="{
                                    active: true === remote_measures.uses_git
                                }"
              >
                <img
                  v-if="remote_measures.uses_git"
                  v-bind:src="
                                        '/images/icon-checked-white.svg'
                                    "
                  alt
                  class="mr-2"
                />
                <input
                  type="radio"
                  name="usesGitOptions"
                  id="usesGitOptionsTrue"
                  :value="true"
                  autocomplete="off"
                  v-model="remote_measures.uses_git"
                />Yes
              </label>
            </div>
            <div class="col-md-4 col-6">
              <label
                class="btn radio-btn"
                v-bind:class="{
                                    active: false === remote_measures.uses_git
                                }"
              >
                <img
                  v-if="!remote_measures.uses_git"
                  v-bind:src="
                                        '/images/icon-checked-white.svg'
                                    "
                  alt
                  class="mr-2"
                />
                <input
                  type="radio"
                  name="usesGitOptions"
                  id="usesGitOptionsFalse"
                  :value="false"
                  autocomplete="off"
                  v-model="remote_measures.uses_git"
                />No
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex w-100 justify-content-center btn-wrapper">
      <div class="col-md-6 col-12 text-center">
        <div class="form-group">
          <button class="btn btn-block" @click="saveChanges()">Save Changes</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CompanyState from "../NewCompanyState";

export default {
  data() {
    return {
      remote_measures: CompanyState.remote_measures
    };
  },

  methods: {
    async getRemoteFriendliness() {
      const res = await axios.get("/company-remote-friendliness");
      const data = res.data.data;
      this.remote_measures.video_conference =
        data.uses_video_conference_tools === 1;
      this.remote_measures.project_management =
        data.uses_project_management_tools === 1;
      this.remote_measures.clear_sop = data.has_clear_sops === 1;
      this.remote_measures.set_communications_protocol =
        data.set_communications_protocol === 1;
      this.remote_measures.help_remote_ready =
        data.needs_help_remote_ready === 1;
      this.remote_measures.schedule_regular_scrums =
        data.schedule_regular_scrums === 1;
      this.remote_measures.uses_git = data.uses_git === 1;
      this.remote_measures.has_tech_team = data.has_tech_team === 1;
    },

    async saveChanges() {
      const res = await axios.get("/get-user-company");
      const data = res.data.data;

      const request_params = {
        uses_git: this.remote_measures.uses_git,
        uses_video_conference_tools: this.remote_measures.video_conference,
        uses_project_management_tools: this.remote_measures.project_management,
        has_clear_sops: this.remote_measures.clear_sop,
        set_communications_protocol: this.remote_measures
          .set_communications_protocol,
        schedule_regular_scrums: this.remote_measures.schedule_regular_scrums,
        needs_help_remote_ready: this.remote_measures.help_remote_ready,
        has_tech_team: this.remote_measures.has_tech_team
      };

      await axios.post(
          `/company-remote-friendliness/${data.id}`,
          request_params
      );
      location.href = "/company-profile/edit#remote";
      window.scrollTo(0, 0);
    }
  },

  mounted() {
    this.getRemoteFriendliness();
  }
};
</script>

<style scoped lang="scss">
.edit-remote-readiness {
  .btn-group {
    display: flex !important;
    .btn {
      input[type="radio"] {
        position: absolute;
        clip: rect(0, 0, 0, 0);
        pointer-events: none;
      }
    }
  }

  .radio-btn {
    margin-right: 0;
    &.active {
      border-radius: 4px;
      background-color: #3592ff;
      color: white;
      border: none;
    }
  }

  .form-group {
    label {
      color: #808fa4;
      font-family: "Open Sans", sans-serif;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0.5px;
      line-height: 22px;
    }
  }

  .tech-team {
    color: #303030;
    font-family: Lato;
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 28px;

    &__description {
      color: #8392a6;
      font-family: "Open Sans", sans-serif;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 24px;
      font-weight: 400;
    }
  }
  .btn-wrapper {
    margin-top: 4rem;

    @media (max-width: 768px) {
      margin-top: 1rem;
    }
    .btn-block {
      border-radius: 6px;
      background-color: #000 !important;
      height: 56px;
      border: none;
      color: #fff;
    }

    .btn {
      background: white;
    }
  }
}

.radio-btn {
  min-width: 108px;
  justify-content: center;
  border-radius: 3px !important;
  background-color: #f2f2f2;
  height: 50px;
  margin-right: 20px;
  display: flex;
  align-items: center;
  color: #00002d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  font-weight: 100;
}

.radio-btn.active {
  background-color: #fff;
  border: 2px solid #5145ff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
}

.radio-btn:last-child {
  margin-right: 0;
}

button,
button:hover {
  padding: 10px 18px;
  border-radius: 6px;
  background-color: #5145ff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
  color: #fff;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
}

.back-button,
.back-button:hover {
  text-decoration: none;
  color: #646efe;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  background: transparent;
}
</style>
